// Query History Mapper
import { QueryHistoryEntity, QueryActionType } from "../../domain/entities/QueryHistoryEntity";
import { QueryHistoryDTO } from "../models/QueryHistoryDTO";
import { QueryMapper } from "./QueryMapper";

export class QueryHistoryMapper {
  static toDomain(dto: QueryHistoryDTO): QueryHistoryEntity {
    return {
      historyId: dto.history_id,
      queryId: dto.query_id,
      actionType: dto.action_type as QueryActionType,
      actionBy: QueryMapper.userToDomain(dto.action_by),
      actionAt: new Date(dto.action_at),
      oldValue: dto.old_value,
      newValue: dto.new_value,
      comment: dto.comment,
    };
  }

  static toDTO(entity: QueryHistoryEntity): QueryHistoryDTO {
    return {
      history_id: entity.historyId,
      query_id: entity.queryId,
      action_type: entity.actionType,
      action_by: QueryMapper.userToDTO(entity.actionBy),
      action_at: entity.actionAt.toISOString(),
      old_value: entity.oldValue,
      new_value: entity.newValue,
      comment: entity.comment,
    };
  }
}

